import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IGenerateReportReq, IGenerateReportRes, ISSRSConfReportResponse } from '@shared/components/reports/IReportingFilterData';
import { IAuthRes } from '@pages/authentication/services/securityNewBack.service';
import { map, switchMap, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SsrsReportsService {
  private baseUrl = environment.apiSSRSurl + 'Seguridad/Authenticate';

  constructor(private http: HttpClient) {}

  getSSRSToken(): Observable<string> {
    const payload = {
      credentials:
        'We3QwQmlmjSnSZ9FNHVlGncenVDuAM/oYo81+KwVk8jGX17daTSex6kyZfFrie0wHEsqoIl692DoBuCeQM3bRWPLTlzRBoW+mhIaFRmwfjj75Es9uK8TV9K8twbVtk0omUCZ76/fUx7+C6qFkl4FPp9FcO0qGx1ug/Ueia2rU9kNLmNOtLLD5Su+C0EvqCqHbZN5j4vze+lDC7N6wRw3VstM/9ekc78k1KgeQHwtf18='
    };

    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post<IAuthRes>(this.baseUrl, payload, { headers }).pipe(map((response) => response.token));
  }

  GetConfReport(report: string): Observable<ISSRSConfReportResponse> {
    return this.getSSRSToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', `Bearer ${token}`);

        const url = `${environment.apiSSRSurl}SSRS/GetConfReport?report=${report}`;
        return this.http.get<ISSRSConfReportResponse>(url, { headers });
      })
    );
  }

  GenerateReport(report: IGenerateReportReq): Observable<IGenerateReportRes> {
    return this.getSSRSToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', `Bearer ${token}`);

        const url = `${environment.apiSSRSurl}SSRS/GenerateReport`;
        return this.http.post<IGenerateReportRes>(url, report, { headers });
      })
    );
  }
}
